import React from "react";
import { Link } from "react-router-dom";
import { Share2, Copy, Users, Wallet, Gift } from "lucide-react";
import { toast } from "sonner";
import { useStore } from "@/context/StoreContext";

export default function Referral() {
  const { user } = useStore();
  const code = user && user !== false ? `SVS-${user.id.slice(-6).toUpperCase()}` : "SVS-GUEST";
  const link = `https://www.shrivrindavanshop.com/?ref=${code}`;

  const copy = () => {
    navigator.clipboard?.writeText(link);
    toast.success("Referral link copied!");
  };

  return (
    <div>
      <section className="bg-secondary text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 text-center">
          <Share2 size={34} className="mx-auto text-primary mb-3" />
          <h1 className="text-4xl sm:text-5xl font-serif font-bold">Share. Shop. Earn.</h1>
          <p className="mt-4 text-white/85 max-w-xl mx-auto">
            Refer customers to eligible Shri Vrindavan Shop products and participate in the platform's referral program.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid md:grid-cols-3 gap-6 mb-10">
          {[
            [Share2, "1. Share your link", "Send your unique referral link to friends and family."],
            [Users, "2. They shop", "Your referrals shop eligible products on the platform."],
            [Gift, "3. You earn rewards", "Earn referral rewards, credited once payouts go live."],
          ].map(([Icon, t, d]) => (
            <div key={t} className="rounded-xl border border-border bg-card p-6 text-center">
              <div className="h-12 w-12 rounded-xl bg-accent text-secondary grid place-items-center mx-auto mb-3"><Icon size={22} /></div>
              <h3 className="font-semibold text-stone-900">{t}</h3>
              <p className="mt-1 text-sm text-stone-500">{d}</p>
            </div>
          ))}
        </div>

        <div className="rounded-2xl border border-border bg-card p-6 sm:p-8">
          <h3 className="font-serif font-bold text-xl text-stone-900">Your Referral Link</h3>
          <div className="mt-4 flex flex-col sm:flex-row gap-3">
            <div className="flex-1 rounded-lg border border-border bg-muted px-4 py-3 text-sm text-stone-700 truncate" data-testid="referral-link">{link}</div>
            <button onClick={copy} data-testid="referral-code-copy-button" className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary text-primary-foreground font-semibold px-5 py-3">
              <Copy size={16} /> Copy Link
            </button>
          </div>
          <div className="mt-4 grid grid-cols-3 gap-4 text-center">
            {[["Referrals", "0"], ["Rewards Earned", "₹0"], ["Referral Code", code]].map(([l, v]) => (
              <div key={l} className="rounded-lg bg-muted p-3">
                <div className="text-lg font-bold text-secondary">{v}</div>
                <div className="text-[11px] text-stone-500">{l}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-6 flex items-start gap-2 text-sm text-amber-800 bg-amber-50 border border-amber-100 rounded-xl p-4">
          <Wallet size={18} className="shrink-0 mt-0.5" />
          <p>Referral reward calculation and payouts are not active yet. They will be enabled with wallet & settlement modules in a later development phase.</p>
        </div>

        {(!user || user === false) && (
          <div className="mt-6 text-center">
            <Link to="/register" className="inline-flex rounded-full bg-secondary text-white font-semibold px-6 py-3">Create an account to join</Link>
          </div>
        )}
      </section>
    </div>
  );
}
